export const successResponseInterceptor = (response) => {
  return Promise.resolve(response);
};
